export const GET_DEMOGRAPHICS = "GET_DEMOGRAPHICS";
export const GET_FACULTY_CONTACTS = "GET_FACULTY_CONTACTS";
export const GET_PERSON_WITH_NAME = "GET_PERSON_WITH_NAME";
export const GET_PERSON_WITH_NAME_FAILURE = "GET_PERSON_WITH_NAME_FAILURE";
export const GET_PERSON_WITH_NAME_SUCCESS = "GET_PERSON_WITH_NAME_SUCCESS";